import script from "./BottomNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./BottomNavigation.vue?vue&type=style&index=0&id=2ef217ad&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef217ad"]])

export default __exports__